export const userDetail = {
  loginname: 'glosys',
  password : "glosys",
};